<template>
  <v-form @submit.prevent>
    <v-row>
      <v-col cols="12" md="9">
        <v-card>
          <v-card-title>
            {{ $t('routes.roles.add') }}
          </v-card-title>
          <v-divider />
          <v-card-text>{{ $t('page.role.add_role_description') }}</v-card-text>
          <v-row class="px-5 pb-5">
            <v-col v-for="(lang, i) in langs" :key="i" cols="12">
              <v-text-field
                v-model="role.translations[lang.key].name"
                :error-messages="$t(errors.translations[lang.key].name, { field: $t('label.name') })"
                :label="$t('label.name')"
                outlined
                hide-details="auto"
              >
                <template v-slot:append>
                  <v-img :src="lang.image" height="14px" width="22px" :alt="lang.key" class="me-2 mt-1"></v-img>
                  <div class="mt-1">{{ lang.native }}</div>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="px-5 pb-5">
            <v-col cols="12">
              <v-select
                v-model="role.assignable_roles"
                :items="available_roles"
                :item-text="item => item.translations[$i18n.locale].name"
                item-value="id"
                :error-messages="$t(errors.assignable_roles, { field: $t('label.role') })"
                hide-details="auto"
                chips
                :label="$t('page.role.roles_to_assign_hint')"
                multiple
                clearable
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card>
          <v-card-text>
            <v-btn
              :disabled="loading"
              :loading="loading"
              color="primary"
              type="submit"
              @click="addRole"
              block
              class="mb-3"
              small
            >
              <v-icon class="mr-1">{{ mdiContentSaveOutline }}</v-icon>
              {{ $t('common.save') }}
            </v-btn>
            <v-btn small block outlined :disabled="loading" @click="$router.push('/roles')">
              <v-icon class="ml-r" small>{{ mdiArrowULeftTop }}</v-icon>
              {{ $t('common.back') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mdiArrowULeftTop, mdiContentSaveOutline } from '@mdi/js'

export default {
  components: {},
  beforeMount() {
    this.langs = this.$store.getters['i18n/langs']
    this.langs.forEach(lang => {
      if (!this.role.translations.hasOwnProperty(lang.key)) {
        this.role.translations[lang.key] = {
          name: '',
        }
      }
      if (!this.errors.translations.hasOwnProperty(lang.key)) {
        this.errors.translations[lang.key] = {
          name: '',
        }
      }
    })

    this.$http('roles/assignable/index').then(res => {
      this.available_roles = res.data
    })
  },
  data() {
    return {
      loading: false,
      langs: [],
      available_roles: [],
      role: {
        translations: {},
        assignable_roles: [],
      },
      errors: {
        translations: {},
      },

      //icons
      mdiArrowULeftTop,
      mdiContentSaveOutline,
    }
  },
  methods: {
    addRole() {
      this.loading = true
      this.$http
        .post('roles/create', this.role)
        .then(res => {
          this.$router.push({
            name: 'roles.edit',
            params: { id: res.data.id },
          })
        })
        .catch(error => {
          if (typeof error == 'object' && typeof error.response.data.error == 'object') {
            this.errors = error.response.data.error
            if (!this.errors.hasOwnProperty('translations')) {
              this.errors.translations = {}
            }
            this.langs.forEach(lang => {
              if (!this.errors.translations.hasOwnProperty(lang.key)) {
                this.errors.translations[lang.key] = {
                  name: '',
                }
              }
            })
          }
        })
        .finally(() => {
          this.loading = false
          document.activeElement.blur()
        })
    },
  },
}
</script>

<style scoped>
.XGutter * {
  padding-right: 8px;
}
</style>
